/**
 * Cart Upsell Accordion
 *
 * Lightweight accordion toggle for the cart upsell section.
 * Re-initializes safely after section re-renders via window.initCartUpsellAccordion().
 */

class CartUpsellAccordion {
  constructor(component) {
    this.component = component;
    this.toggle = component.querySelector('[data-cart-upsell-toggle]');
    this.content = component.querySelector('[data-cart-upsell-content]');

    if (!this.toggle || !this.content) return;

    this.bindEvents();
  }

  bindEvents() {
    this.toggle.addEventListener('click', this.handleToggle.bind(this));
    this.toggle.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleToggle() {
    const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.toggle.setAttribute('aria-expanded', 'true');
    this.content.hidden = false;
  }

  close() {
    this.toggle.setAttribute('aria-expanded', 'false');
    this.content.hidden = true;
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleToggle();
    }
  }
}

function initCartUpsellAccordion() {
  const components = document.querySelectorAll('[data-cart-upsell]');

  components.forEach(component => {
    if (component.dataset.accordionInitialized === 'true') return;

    new CartUpsellAccordion(component);
    component.dataset.accordionInitialized = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartUpsellAccordion);
} else {
  initCartUpsellAccordion();
}

document.addEventListener('shopify:section:load', initCartUpsellAccordion);

window.initCartUpsellAccordion = initCartUpsellAccordion;
